module.exports = __webpack_public_path__ + "img/close_icon.537492b3.svg";